export const WHATSAPP_SUPPORT_URL = 'https://wa.me/447403654950';
export const TELEGRAM_SUPPORT_URL = 'https://t.me/tivigodestek';

const SUPHERO_READY_EVENT = 'tivigo:suphero-chat-ready';

const clickSupheroLauncher = () => {
  const launcher = document.querySelector('.tc-launcher');
  if (!(launcher instanceof HTMLElement)) return false;
  launcher.click();
  return true;
};

export const notifySupheroChatReady = () => {
  window.dispatchEvent(new CustomEvent(SUPHERO_READY_EVENT));
};

export const openSupheroChat = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;
  if (clickSupheroLauncher()) return true;

  const openWhenReady = () => clickSupheroLauncher();
  window.addEventListener(SUPHERO_READY_EVENT, openWhenReady, { once: true });
  window.setTimeout(() => window.removeEventListener(SUPHERO_READY_EVENT, openWhenReady), 5000);
  return false;
};
